import { call, put, select } from 'redux-saga/effects';
import { getUserInfo, deleteUser } from "../actions/Users";


export function* initialize({ firebaseApp }) {
}

export function* addUserSagas(action) {
}

export function* getUserInfoSagas(action) {
    const { firebase } = yield select(state => state)
    var doc_name_id = action.payload.data
    const doc = yield call([firebase.stationsCollection, firebase.stationsCollection.doc], doc_name_id);
    const docGet = yield call([doc, doc.get])
    yield put({ type: getUserInfo, payload: docGet.data() })
}

export function* deleteUserSagas(action) {
    const { firebase } = yield select(state => state)
    var doc_name_id = action.payload.data
    const doc = yield call([firebase.stationsCollection, firebase.stationsCollection.doc], doc_name_id);
    const docGet = yield call([doc, doc.get])
    yield put({ type: deleteUser, payload: docGet.data() })
}